<button mat-icon-button color="primary" [disabled]="requestDisabled" (click)="requestLog($event)">
  <mat-icon>upload_file</mat-icon>
</button>
<button mat-icon-button color="primary" #tooltip="matTooltip" matTooltipPosition="above"
  matTooltipClass="filter-tooltip" matTooltip="Log created at: {{logDate | date: 'dd MMM H:mm:ss'}}"
  [disabled]="downloadDisabled" (click)="downloadLog($event)">
  <mat-icon>file_download</mat-icon>
</button>